import React, { useState } from "react";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import { Box, Stack, TextField } from "@mui/material";
import axios from "axios";
import { useSnackbar } from "notistack";
import endpoint from "../config"

const UploadForm=({ genres, contentRatings, onClose, fetchVideos })=>{
  const { enqueueSnackbar } = useSnackbar();
  // const [formData, setFormData] = useState({
  //     videoLink: "",
  //     title: "",
  //     previewImage: "",
  //     genre: "",
  //     contentRating: "",
  //     releaseDate: "",
  //   });
  const initialState = {
    videoLink: "",
    title: "",
    previewImage: "",
    genre: "",
    contentRating: "",
    releaseDate: "",
  };
  const [formData, setFormData] = useState(initialState);
  //   const [isError, setIsError]=useState(false);
  //   const [errorMsg, setErrorMsg]=useState("Test error");

  //   const handleInputChange = (e) => {
  //     const newFormData={
  //         ...formData,
  //         [e.target.name]: e.target.value
  //     }
  //     setFormData(newFormData);
  //   };
  const handleInputChange = (e) => {
    const [key, value] = [e.target.name, e.target.value];
    setFormData({ ...formData, [key]: value });
  };
  //   const handleSubmit = () => {
  //     if (!validateInput(formData)) return;

  //     postVideoAPI(formData);
  //   };
  const getDate = (value) => {
    const date = new Date(value);
    const options = { day: "numeric", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-IN", options);
  };
  //   const postVideoAPI=async(reqBody)=>{
  //     try{
  //         await axios.post(endpoint, reqBody);
  //         setIsError(false);
  //         setErrorMsg("")
  //         fetchVideos()
  //         onClose();
  //     } catch(e){
  //         if (e.response){
  //             setIsError(true);
  //             setErrorMsg(e.response.data.message);
  //         } else {
  //             enqueueSnackbar(
  //                 "Something went wrong. Check that the backend is running, reachable and returns valid JSON.",
  //                 {variant: "error"}
  //             );
  //         }
  //     }
  //   };
  const handleSubmit = async () => {
    if (!validateInput(formData)) return;
  
    const postData = {
      ...formData,
       releaseDate: getDate(formData.releaseDate),
    };
  
    try {
      const req = await axios.post(endpoint, postData);
      console.log(req.data);
      if (req.status === 201) {
        console.log("POST Request made with", postData);
        enqueueSnackbar("Video Uploaded Successfully", { variant: "success" });
        // await fetchVideos();
        setFormData(initialState);
        onClose();
      }
    } catch (e) {
      if (e && e.response && e.response.data) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar("Something went wrong", { variant: "error" });
      }
    }
  };
 
  const validateInput = (data) => {
    let validData = { ...data };
        
    if (!validData.videoLink) {
       enqueueSnackbar("Video link is required!", {
          variant: "warning",
       });
        return false;
    }
    if (!validData.title) {
      enqueueSnackbar("Title is required!", {
         variant: "warning",
      });
       return false;
    }
    if (!validData.genre) {
      enqueueSnackbar("Genre is required!", {
        variant: "warning",
      });
      return false;
    }
    if (!validData.contentRating) {
      enqueueSnackbar("Age group is required!", {
        variant: "warning",
      });
      return false;
    }
    if (!validData.releaseDate) {
      enqueueSnackbar("Upload and Publish date is required!", {
        variant: "warning",
      });
      return false;
    }
    return true;
  };


  return (
    <Box>
      <Stack spacing={3}>
        <Stack spacing={1.5}>
          <TextField
            required
            id="upload-btn-video"
            className="form-element"
            variant="outlined"
            label="Video Link"
            placeholder="Video Link"
            helperText="This link will be used to derive the video"
            fullWidth
            name="videoLink"
            value={formData.videoLink}
            onChange={handleInputChange}
          />
          <TextField
            required
            id="upload-btn-image"
            className="form-element"
            variant="outlined"
            label="Thumbnail Image"
            placeholder="Thumbnail Image Link"
            helperText="This link will be used to derive the video"
            fullWidth
            name="previewImage"
            value={formData.previewImage}
            onChange={handleInputChange}
          />
          <TextField
            required
            id="upload-btn-title"
            className="form-element"
            variant="outlined"
            label="Title"
            placeholder="Title"
            helperText="This link will be used to derive the video"
            fullWidth
            name="title"
            value={formData.title}
            onChange={handleInputChange}      
          />
          <TextField
            select
            required
            id="upload-btn-genre"
            className="select-input form-element"
            label="Genre"
            helperText="Genre will help in categorizing your videos"
            name="genre"
            value={formData.genre}
            onChange={handleInputChange}
          >
          {genres
            .filter((option) => option.value !== "All")
            .map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
            <TextField
            select
            required
            id="upload-btn-content-rating"
            className="select-input form-element"
            label="Suitable age group for the clip"
            helperText="This will be used to filter videos on age group suitability"
            name="contentRating"
            value={formData.contentRating}
            onChange={handleInputChange}
          >
            {contentRatings.map((option) => (
              <MenuItem key={option.value} value={option.label}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            type="date"
            id="upload-btn-release-date"
            className="form-element"
            label="Release Date"
            name="releaseDate"
            helperText="This will be used to sort videos"
            onChange={handleInputChange}
            value={formData.releaseDate}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Stack>
        <Stack direction="row" py="1rem" spacing={2}>
          <Button
            id="upload-btn-submit"
            variant="contained"
            onClick={handleSubmit}
            color="primary"
          >
           Upload Video
          </Button>
          <Button
            id="upload-btn-cancel"
            variant="text"
            color="error"
             onClick={onClose}
          >
          Cancel
          </Button>
      </Stack>
        {/* {isError && (
          <div className="error-msg"> Something went wrong={errorMsg}</div>
         )} */}
    </Stack>
   </Box>
  );
}

export default UploadForm;